import { tempAccessToken } from "../../utils/authUtils";
import axios from "axios";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { useEffect, useState } from "react";
import {
    AppBar,
    Autocomplete,
    Box,
    CircularProgress,
    Paper,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import './index.css';
import ApiService from "../../utils/fetch";

const powerBIURL = `${process.env.REACT_APP_BACKEND_BASE_URL}/powerBI/embedDetails/`;


const IBPHomePage = () => {
    const [reportId, setReportId] = useState(null);
    const [embedUrl, setEmbedUrl] = useState(null);
    const [pageName, setPageName] = useState(null);
    const [accessToken, setAccessToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const commonGroupId = "be3acc5f-bfe8-42da-8a07-3ff5cccc1bb3"
    const ruleLevelReportId = "829a3168-d41a-43e6-8956-9d48dcc64f50";
    const ruleLevelPageId = "a89f7c8055132d0d7081";

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            try {
                const response = await ApiService.get(`${powerBIURL}group/${commonGroupId}/report/${ruleLevelReportId}`);
                const data = response.data;
                setEmbedUrl(data.embedUrl || null);
                setAccessToken(data.accessToken || null);
                setReportId(data.reportId);
                setPageName(ruleLevelPageId);
            } catch (error) {
                console.error("Report fetch failed", error);
                setReportId(null);
                setEmbedUrl(null);
                setAccessToken(null);
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, []);
    const embedConfig = {
        type: "report",
        id: reportId,
        embedUrl: `${embedUrl?.split("&pageName=")[0]}&pageName=${pageName}`,
        accessToken: accessToken,
        tokenType: models.TokenType.Embed,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
            },
            navContentPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToPage,
            },
        },
    };

    return (
        <div style={{ margin: 10 }} >
            {loading ? (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : reportId && embedUrl && accessToken ? (
                <div>
                    <PowerBIEmbed
                        embedConfig={embedConfig}
                        cssClassName="powerBi_cls"
                    />
                </div>
            ) : (
                <Typography
                    variant="body1"
                    color="textSecondary"
                    sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    No report available
                </Typography>
            )}
        </div>
    )
}

export default IBPHomePage;